import { t } from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

const StepperNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding-inline: 0.5rem;

  button {
    // The visible dash is drawn by ::before; the button itself stays 24px tall
    // so the pointer/touch target meets WCAG 2.5.8 despite the thin dash.
    flex: 1 1 0;
    max-width: 7.5rem;
    min-height: 1.5rem;
    display: flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;

    &::before {
      content: '';
      width: 100%;
      height: 2px;
      border-radius: 999px;
      background-color: var(--login-dash-idle);
      transition:
        background-color 200ms ease-out,
        height 200ms ease-out;

      @media (prefers-reduced-motion: reduce) {
        transition: none;
      }
    }

    &[aria-current='step']::before {
      height: 4px;
      background-color: var(--login-primary);
    }

    &:focus-visible {
      // The subtle focus ring token is too light to clear 3:1 against the cream surface.
      outline: 2px solid var(--login-primary-strong);
      outline-offset: 2px;
      border-radius: 999px;
    }
  }
`;

interface DashStepperNavigationProps {
  stepCount: number;
  currentStep: number;
  onStepChange: (index: number) => void;
  className?: string;
}

export const DashStepperNavigation = ({
  stepCount,
  currentStep,
  onStepChange,
  className,
}: DashStepperNavigationProps) => (
  <StepperNav className={className}>
    {Array.from({ length: stepCount }, (_, index) => (
      <button
        key={index}
        aria-current={currentStep === index ? 'step' : undefined}
        aria-label={t`Stap ${index + 1}`}
        data-test-id="carouselStep"
        type="button"
        onClick={() => onStepChange(index)}
      />
    ))}
  </StepperNav>
);
